var CalculatorAirCompressor = function () {

	//currencies
	var USD = 0, BRL = 0, EUR = 0, GBP = 0;

	//inputs
	var numberOfAirCompressors,
		oilPerAirCompressor,
		oilDrainInterval,
		estimatedPriceUserOil,
		estimatedPriceMobilOil,
		estimatedTimeToChangeOil,
		costLabor,
		flushingOilVolume,
		flushingOilTime;

	//special buttons
	var currencyButton,
		oilUnitButton;

	//display fields
	var exchanges,
		oilUsedAnnually,
		oilUsedAnnuallyMobilSolution,
		oilCostSaved,
		annualCostOfGearOil,
		annualCostOfGearOilMobilSolution,
		oilCostSaving,
		laborCostOilChanges,
		laborCostOilChangesMobilSolution,
		laborCostSavingYear,
		costInitialFlush,
		finalValue;

	var initializeInputs = function () {

		//inputs
		numberOfAirCompressors = $("#numberOfAirCompressors");
		oilPerAirCompressor = $("#oilPerAirCompressor");
		oilDrainInterval = $("#oilDrainInterval");
		estimatedPriceUserOil = $("#estimatedPriceUserOil");
		estimatedPriceMobilOil = $("#estimatedPriceMobilOil");
		estimatedTimeToChangeOil = $("#estimatedTimeToChangeOil");
		costLabor = $("#costLabor");
		flushingOilVolume = $("#flushingOilVolume");
		flushingOilTime = $("#flushingOilTime");

		//special buttons
		currencyButton = "R$";
		oilUnitButton = "gal";

		//display fields
		exchanges = $("#exchanges");
		oilUsedAnnually = $("#oilUsedAnnually");
		oilUsedAnnuallyMobilSolution = $("#oilUsedAnnuallyMobilSolution");
		oilCostSaved = $("#oilCostSaved");
		annualCostOfGearOil = $("#annualCostOfGearOil");
		annualCostOfGearOilMobilSolution = $("#annualCostOfGearOilMobilSolution");
		oilCostSaving = $("#oilCostSaving");
		laborCostOilChanges = $("#laborCostOilChanges");
		laborCostOilChangesMobilSolution = $("#laborCostOilChangesMobilSolution");
		laborCostSavingYear = $("#laborCostSavingYear");
		costInitialFlush = $("#costInitialFlush");
		finalValue = $("#finalValue");
	};

	var calculate = function () {

		//exchanges
		exchanges.val(3 * oilDrainInterval.val());

		//oilUsedAnnually
		var resultGallons = parseFloat(convertUnitToGallons(oilPerAirCompressor.val(), oilUnitButton)).toFixed(1);
		var oilUsedAnnuallyResult = numberOfAirCompressors.val() * resultGallons * 365 * 24 / oilDrainInterval.val();
		oilUsedAnnually.text(checkResultValue(convertGallonsToUnit(Math.round(oilUsedAnnuallyResult), $(".measure-val.active").attr("id"))));

		//oilUsedAnnuallyMobilSolution
		var oilUsedAnnuallyMobilSolutionResult = oilUsedAnnuallyResult * oilDrainInterval.val() / exchanges.val();
		oilUsedAnnuallyMobilSolution.text(checkResultValue(convertGallonsToUnit(Math.round(oilUsedAnnuallyMobilSolutionResult), $(".measure-val.active").attr("id"))));

		//oilCostSaved
		var oilCostSavedResult = oilUsedAnnuallyResult - oilUsedAnnuallyMobilSolutionResult;
		oilCostSaved.text(checkResultValue(convertGallonsToUnit(Math.round(oilCostSavedResult), $(".measure-val.active").attr("id"))) + " " + $(".measure-val.active").val());

		//annualCostOfGearOil
		var annualCostOfGearOilResult = estimatedPriceUserOil.val() * oilUsedAnnuallyResult;
		annualCostOfGearOil.text(formatDisplayMoney(checkResultValue(annualCostOfGearOilResult)));

		//annualCostOfGearOilMobilSolution
		var annualCostOfGearOilMobilSolutionResult = estimatedPriceMobilOil.val() * oilUsedAnnuallyMobilSolutionResult;
		annualCostOfGearOilMobilSolution.text(formatDisplayMoney(checkResultValue(annualCostOfGearOilMobilSolutionResult)));

		//oilCostSaving
		var oilCostSavingResult = annualCostOfGearOilResult - annualCostOfGearOilMobilSolutionResult;
		oilCostSaving.data("is-negative", oilCostSavingResult < 0 ? true : false);
		oilCostSaving.text(formatDisplayMoney(checkResultValue(oilCostSavingResult), oilCostSaving.data("is-negative")));

		//laborCostOilChanges
		var laborCostOilChangesResult = numberOfAirCompressors.val() * estimatedTimeToChangeOil.val() * costLabor.val() * 365 * 24 / oilDrainInterval.val();
		laborCostOilChanges.text(formatDisplayMoney(checkResultValue(laborCostOilChangesResult)));

		//laborCostOilChangesMobilSolution
		var laborCostOilChangesMobilSolutionResult = numberOfAirCompressors.val() * estimatedTimeToChangeOil.val() * costLabor.val() * 365 * 24 / exchanges.val();
		laborCostOilChangesMobilSolution.text(formatDisplayMoney(checkResultValue(laborCostOilChangesMobilSolutionResult)));

		//laborCostSavingYear
		var laborCostSavingYearResult = laborCostOilChangesResult - laborCostOilChangesMobilSolutionResult;
		laborCostSavingYear.data("is-negative", laborCostSavingYearResult < 0 ? true : false);
		laborCostSavingYear.text(formatDisplayMoney(checkResultValue(laborCostSavingYearResult), laborCostSavingYear.data("is-negative")));

		//costInitialFlush
		var costInitialFlushResult = (flushingOilVolume.val() * numberOfAirCompressors.val() * estimatedPriceMobilOil.val() * 365 * 24 / exchanges.val() + flushingOilTime.val() * numberOfAirCompressors.val() * costLabor.val() * 365 * 24 / exchanges.val());
		costInitialFlush.data("is-negative", costInitialFlushResult < 0 ? true : false);
		costInitialFlush.text(formatDisplayMoney(checkResultValue(costInitialFlushResult), costInitialFlush.data("is-negative")));

		//finalValue
		var finalValueResult = oilCostSavingResult + laborCostSavingYearResult - costInitialFlushResult;
		finalValue.data("is-negative", finalValueResult < 0 ? true : false);
		finalValue.text(formatDisplayMoney(checkResultValue(finalValueResult), finalValue.data("is-negative")));

		convertDisplayValues();
	};

	var convertUnitToGallons = function (value, unit) {
		switch (unit) {
			case "lt": return value * 0.26417;
			case "gal": return value;
		}
	};

	var convertGallonsToUnit = function (value, unit) {
		switch (unit) {
			case "lt": return value / 0.26417;
			case "gal": return value;
		}
	};

	var convertDisplayValues = function () {
		var currencyValue = 0;

		if (currencyButton === "R$")
			currencyValue = BRL;
		else if (currencyButton === "£")
			currencyValue = GBP;
		else if (currencyButton === "€")
			currencyValue = EUR;
		else
			currencyValue = USD;

		$(".displayMoney").each(function () {
			$(this).text(formatDisplayMoney((formatInputValue($(this).text()) * currencyValue).toFixed(2), $(this).data("is-negative")));
		});
	};

	var checkResultValue = function (value) {
		if (isNaN(value) || value === Infinity)
			return 0;
		else if (value < 0)
			return Math.round(value * -1);
		else
			return Math.round(value);
	};

	var formatDisplayMoney = function (value, isNegative) {
		if (currencyButton === "R$") {
			if (isNegative) {
				var brazilianValue = parseFloat(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
				brazilianValue = brazilianValue.substring(0, 3) + "(" + brazilianValue.substring(3, brazilianValue.length) + ")";
				return brazilianValue;
			}
			else {
				return parseFloat(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
			}
		}
		else {
			if (isNegative) {
				return currencyButton + " " + "(" + value.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,') + ")";
			}
			else {
				return currencyButton + " " + value.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
			}
		}
	};

	var formatInputValue = function (value) {
		if (currencyButton === "R$") {
			var result = value.toString().replace(/\./g, "").replace(/,/g, ".").replace(/\(|\)/g, "");
			return parseFloat(result.substring(3, result.length));
		}
		else {
			return parseFloat(value.toString().replace(/,/g, "").replace(currencyButton + " ", "").replace(/\(|\)/g, ""));
		}
	};

	var isInt = function (value) {
		return value % 1 === 0;
	};

	this.init = function () {

		$.ajax({
			type: "GET",
			url: "https://api.exchangeratesapi.io/latest",
			data: { base: "USD" },
			async: false,
			success: function (response) {

				USD = response.rates.USD;
				BRL = response.rates.BRL;
				EUR = response.rates.EUR;
				GBP = response.rates.GBP;
			},
			error: function (e) {
				console.log(e);
			}
		});

		initializeInputs();

		$('.valuesChanged').on('keydown', function (e) {

			// Allow: backspace, delete, tab, escape, enter and .
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything

				setTimeout(function () {
					calculate();
				}, 10);
				
				return;
			}

			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}

			setTimeout(function () {
				calculate();
			}, 10);
		});

		$(".coin-val, .measure-val, .frequency").click(function () {
			$(this).parent().find(".active").removeClass("active");
			$(this).addClass("active");
		});

		$(".coin-val").click(function () {
			currencyButton = $(this).val();
			$(".currency").text($(this).val());
			calculate();
		});

		$(".measure-val").click(function () {
			var resultGallons = [];

			if (oilUnitButton === "gal") {
				resultGallons.push(convertGallonsToUnit(oilPerAirCompressor.val(), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(formatInputValue(oilUsedAnnually.text()), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(formatInputValue(oilUsedAnnuallyMobilSolution.text()), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(formatInputValue(oilCostSaved.text()), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(flushingOilVolume.val(), $(this).attr("id")));
			}
			else {
				resultGallons.push(convertGallonsToUnit(convertUnitToGallons(oilPerAirCompressor.val(), oilUnitButton), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(convertUnitToGallons(formatInputValue(oilUsedAnnually.text()), oilUnitButton), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(convertUnitToGallons(formatInputValue(oilUsedAnnuallyMobilSolution.text()), oilUnitButton), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(convertUnitToGallons(formatInputValue(oilCostSaved.text()), oilUnitButton), $(this).attr("id")));
				resultGallons.push(convertGallonsToUnit(convertUnitToGallons(flushingOilVolume.val(), oilUnitButton), $(this).attr("id")));
			}

			for (var i = 0; i < resultGallons.length; i++) {

				var resultGallonsItem = resultGallons[i];

				if (resultGallonsItem === 0 || resultGallonsItem === "" || resultGallonsItem === "undefined") {
					continue;
				}

				switch (i) {

					case 0:

						oilPerAirCompressor.val(resultGallonsItem.toFixed(1));

						break;

					case 1:

						if (isInt(resultGallonsItem.toFixed(1))) {
							oilUsedAnnually.text(parseInt(resultGallonsItem.toFixed(1)));
						}
						else {
							oilUsedAnnually.text(checkResultValue(resultGallonsItem));
						}

						break;

					case 2:

						if (isInt(resultGallonsItem.toFixed(1))) {
							oilUsedAnnuallyMobilSolution.text(parseInt(resultGallonsItem.toFixed(1)));
						}
						else {
							oilUsedAnnuallyMobilSolution.text(checkResultValue(resultGallonsItem));
						}

						break;

					case 3:

						if (isInt(resultGallonsItem.toFixed(1))) {
							oilCostSaved.text(parseInt(resultGallonsItem.toFixed(1)) + " " + $(this).val());
						}
						else {
							oilCostSaved.text(checkResultValue(resultGallonsItem) + " " + $(this).val());
						}

						break;

					case 4:

						flushingOilVolume.val(resultGallonsItem.toFixed(1));

						break;
				}
			}

			oilUnitButton = $(this).attr("id");
			$(".volume").text($(this).text());
		});
	};

	return this.init();
}